import React, {useContext} from "react";
import CatalogOverview from "../CatalogOverview/CatalogOverview";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import {SocketContext} from "../../../contexts/SocketContext";
import UiContext from "../../../contexts/UiContext";
import {useMatch} from "react-router-dom";

type Props = {};

export const CatalogOverviewWrapper = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const match = useMatch("/catalogs/:guid");

    return <CatalogOverview
        match={match}
        socket={socket}
        notifyFn={uiContext.notifyFn}
        toggleSidebar={uiContext.toggleSidebar}
        setSidebarComponent={uiContext.setSidebarComponent}
        setActivityIndicator={uiContext.setActivityIndicator}
        userModel={userModel}
        supplierModel={supplierModel}
        showHiddenFeatures={uiContext.showHiddenFeatures}
    />;
};
